module.exports = __webpack_public_path__ + "static/fonts/Fact-Compressed.c68602f.eot";